<template>
  <div
    class="row border border-azul-claro2 mx-0 text-azul mt-3 mb-5 postulante1"
    v-if="resultado"
  >
    <div
      class="col-12 col-sm-8 col-lg-4 d-flex align-items-center text-left pt-3 pb-0 pb-sm-3"
    >
      <div class="col-3 px-0">
        <img
          v-if="resultado.postulante.sexo == 'M'"
          src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/icono-hijo.png"
          class="img-fluid"
          alt
        />
        <img
          v-else
          src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/icono-hija.png"
          class="img-fluid"
          alt
        />
      </div>
      <div class="pl-3">
        <div class="gilmer text-uppercase">Postulante</div>
        <div class="font-weight-bold">
          {{ resultado.postulante.nombres }}
          {{ resultado.postulante.paterno }}
          {{ resultado.postulante.materno }}
        </div>
      </div>
    </div>
    <div
      class="col-auto w-1px border-left border-azul-claro2 d-none d-sm-block px-0"
    ></div>
    <div
      class="col-12 col-sm col-lg text-center pt-1 pt-sm-2 pb-2 d-flex align-items-center"
    >
      <div class="col-3 px-0 d-block d-sm-none"></div>
      <div class="mx-auto px-auto col-9 col-sm text-left text-sm-center">
        <div class="d-inline-block d-sm-block gilmer text-uppercase">Curso</div>
        <div class="d-inline-block d-sm-block font-weight-bold">
          {{ resultado.postulante.glosaNivel }}
        </div>
      </div>
    </div>
    <div
      class="col-auto w-1px border-left border-azul-claro2 d-none d-lg-block px-0"
    ></div>
    <div
      class="col-12 h-1px border-top border-azul-claro2 d-block d-lg-none px-0"
    ></div>
    <div
      class="col text-black-50 py-3 d-flex align-items-center justify-content-center"
    >
      <!--CODICIONAL ACA-->
      <div
        :class="
          [
            resultado.estado === 'ACEPTADO' ||
            resultado.estado === 'ACEPTADO_DEFAULT' ||
            resultado.estado === 'LISTA_ESPERA'
              ? 'text-success'
              : 'text-azul-medio'
          ] + ' gilmer text-uppercase text-center'
        "
      >
        <div class="d-inline-block d-lg-block">
          <FontAwesomeIcon
            v-if="
              resultado.estado === 'ACEPTADO' ||
                resultado.estado === 'ACEPTADO_DEFAULT' ||
                resultado.estado === 'LISTA_ESPERA'
            "
            icon="thumbs-up"
            class="h4 mb-0"
          ></FontAwesomeIcon>
          <FontAwesomeIcon
            v-if="resultado.estado === 'SIN_ASIGNACION'"
            icon="exclamation-circle"
            class="h4 mb-0"
          ></FontAwesomeIcon>
        </div>
        <div class="d-inline-block d-lg-block px-1">{{ mensajes.titulo }}</div>
        <div class="d-inline-block d-lg-block font-weight-bold text-nowrap">
          {{ mensajes.subtitulo }}
        </div>
        <div
          class="d-inline-block d-lg-block small text-azul font-weight-light"
        >
          EN
          {{
            resultado.periodo == 1
              ? "PERIODO PRINCIPAL"
              : resultado.periodo == 2
              ? "LISTAS DE ESPERA"
              : "PERIODO COMPLEMENTARIO"
          }}
        </div>
      </div>
    </div>
    <div
      class="col-auto w-1px border-left border-azul-claro2 d-none d-lg-block px-0"
    ></div>
    <div
      class="col-12 col-lg-3 d-flex flex-column align-items-center justify-content-center py-4 px-auto px-sm-5 px-lg-3"
      :class="[
        resultado.estado === 'RECHAZADO' ? 'bg-azul-medio' : 'bg-azul-claro3'
      ]"
    >
      <button
        v-if="resultado.validacion != ''"
        class="btn btn-azul-outline gilmer w-100 text-left pr-3 text-uppercase"
        :data-testid="'button-listado-descargar-comprobante-' + resultado.id"
        @click.prevent="descargarComprobante"
      >
        COMPROBANTE DE RESULTADOS
        <FontAwesomeIcon
          icon="download"
          class="float-right py-0 h4"
        ></FontAwesomeIcon>
      </button>
      <div
        v-else
        class="d-inline-block d-lg-block font-weight-bold text-nowrap"
      >
        SIN COMPROBANTE
      </div>
    </div>
  </div>
</template>
<script>
import ApiResultados from "@/services/ApiResultados";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faCheckDouble,
  faTrashAlt,
  faThumbsUp,
  faEye,
  faPencilAlt,
  faDownload,
  faCheck,
  faExclamationCircle,
  faAngleRight
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
library.add(
  faBell,
  faCheckDouble,
  faTrashAlt,
  faThumbsUp,
  faEye,
  faPencilAlt,
  faDownload,
  faCheck,
  faExclamationCircle,
  faAngleRight
);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    resultado: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mensajes: {
        titulo: "",
        subtitulo: ""
      }
    };
  },
  mounted() {
    this.textoResultadoTipoAsignacion();
    this.textoResultado();
  },
  methods: {
    textoResultadoTipoAsignacion() {
      switch (this.resultado.tipoAsignacion) {
        case "NO_CORRE_LISTA_ESPERA_SIN_ASIGNACION":
          this.mensajes = {
            titulo: "SIN ESTABLECIMIENTO",
            subtitulo: ""
          };
          break;
      }
    },
    textoResultado() {
      switch (this.resultado.estado) {
        case "LISTA_ESPERA":
        case "ACEPTADO":
          this.mensajes = {
            titulo: "ADMITIDO EN",
            subtitulo: "ESTABLECIMIENTO"
          };
          break;
        case "ACEPTADO_DEFAULT":
          this.mensajes = {
            titulo: "ADMITIDO",
            subtitulo: "POR OMISIÓN"
          };
          break;
        case "RECHAZADO":
          this.mensajes = {
            titulo: "ESTABLECIMIENTO",
            subtitulo: "RECHAZADO"
          };
          break;
        case "SIN_ASIGNACION":
          this.mensajes = {
            titulo: "SIN ESTABLECIMIENTO",
            subtitulo: "ASIGNADO"
          };
          break;
        case "LISTA_ESPERA_AUTOMATICA":
          this.mensajes = {
            titulo: "SIN ESTABLECIMIENTO",
            subtitulo: "LISTA DE ESPERA AUTOMATICA"
          };
          break;
      }
    },
    async descargarComprobante() {
      this.$gtag.event("descargar-comprobante-resultado", {
        event_category: "postulacion",
        event_label: "descargar-comprobante-resultado-listado-postulantes",
        value: ""
      });
      window.open(
        PLATAFORMA.COMPROBANTE +
          "descargar-resultado?resultado=" +
          this.resultado.validacion,
        "_blank"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/postulante/ItemPostulanteResultado.vue